export const cx = (...classes: Array<string | false | null | undefined>) =>
  classes.filter(Boolean).join(" ");

export const canvasPanelClassNames = {
  panel:
    "absolute bottom-[4.5rem] left-32 z-20 flex max-h-[75vh] w-[500px] flex-col gap-3 overflow-y-auto rounded-[6px] border border-[rgba(74,58,31,0.12)] bg-[rgba(245,240,230,0.98)] p-3 shadow-[0_20px_40px_rgba(58,45,20,0.14)] backdrop-blur-[10px]",
  panelHeader: "flex items-center justify-between gap-3",
  panelTitle: "m-0 text-[11px] font-bold uppercase tracking-[0.08em] text-[#4b3e27]",
  iconButton:
    "inline-flex h-6 w-6 cursor-pointer items-center justify-center rounded-full border-0 bg-[rgba(33,27,18,0.09)] text-[#332917]",
  tabList: "grid grid-cols-4 gap-1 rounded-md bg-[rgba(74,58,31,0.08)] p-1",
  tabButton: "rounded-md px-2 py-1 text-[10px] font-semibold transition",
  tabActive: "bg-white text-[#1f2937] shadow-sm",
  tabInactive: "text-[#6c5b3d] hover:bg-white/60",
  section: "mt-1 border-t border-[rgba(74,58,31,0.12)] pt-3",
  sectionStack: "mt-1 flex flex-col gap-3 border-t border-[rgba(74,58,31,0.12)] pt-3",
  sectionTitle: "m-0 text-[11px] font-bold uppercase tracking-[0.08em] text-[#4b3e27]",
  fieldLabel: "flex flex-col gap-1 text-[11px] font-medium text-[#4b3e27]",
  fieldLabelWithTop: "mt-2 flex flex-col gap-1 text-[11px] font-medium text-[#4b3e27]",
  control:
    "w-[150px] max-w-full self-start rounded-md border border-[rgba(74,58,31,0.18)] bg-white px-2 py-1 text-[12px] text-[#1f2937]",
  selectControl:
    "w-[220px] max-w-full self-start rounded-md border border-[rgba(74,58,31,0.18)] bg-white px-3 py-2 text-[13px] font-semibold leading-5 text-[#1f2937]",
  disabledControl:
    "w-[150px] max-w-full self-start rounded-md border border-[rgba(74,58,31,0.18)] bg-white px-2 py-1 text-[12px] text-[#1f2937] disabled:bg-[rgba(74,58,31,0.05)]",
  checkboxRow: "flex items-center gap-2 rounded-md bg-white px-2 py-1 text-[12px] text-[#1f2937]",
  compactCheckboxRow: "flex items-center gap-1 rounded-md bg-white px-2 py-1 text-[11px] text-[#1f2937]",
  card: "rounded-md border border-[rgba(74,58,31,0.12)] bg-white p-3",
  cardStack: "mt-2 flex flex-col gap-3 rounded-md border border-[rgba(74,58,31,0.12)] bg-white p-3",
  bodyText: "text-[12px] font-bold text-[#1f2937]",
  mutedText: "text-[10px] leading-snug text-[#6c5b3d]",
  colorInput:
    "h-9 w-[150px] max-w-full self-start cursor-pointer rounded-md border border-[rgba(74,58,31,0.18)] bg-white p-1",
};
